import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, User, Coins, FileText } from 'lucide-react';

const MobileNavBar: React.FC = () => {
  const location = useLocation();

  // Determinar qué ruta está activa
  const isActive = (path: string) => {
    if (path === '/dashboard' && location.pathname === '/') return true;
    return location.pathname === path;
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 sm:hidden">
      {/* Contenedor principal con efecto de cristal */}
      <div className="relative bg-black/80 backdrop-blur-xl border-t border-blue-600/30 shadow-[0_-4px_20px_rgba(37,99,235,0.25)] overflow-hidden">
        {/* Fondo con gradiente */}
        <div className="absolute inset-0 bg-gradient-to-r from-blue-950/90 via-indigo-950/90 to-blue-950/90"></div>

        {/* Efecto de malla futurista */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAwIDEwIEwgMjAgMTAgTSAxMCAwIEwgMTAgMjAiIHN0cm9rZT0iIzgwODBmZjEwIiBzdHJva2Utd2lkdGg9IjEiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9InVybCgjZ3JpZCkiLz48L3N2Zz4=')] opacity-10"></div>

        {/* Brillo superior */}
        <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-blue-600/0 via-blue-600/50 to-blue-600/0"></div>

        {/* Contenedor de los botones - Actualizado a 4 columnas */}
        <div className="relative grid grid-cols-4 gap-1 p-1">
          {/* Botón App/Dashboard - Colores púrpura */}
          <Link
            to="/dashboard"
            className={`relative flex flex-col items-center justify-center py-2.5 rounded-md transition-all duration-300 ${isActive('/dashboard')
                ? 'bg-gradient-to-b from-purple-600/40 to-purple-800/30 border border-purple-500/40 shadow-[0_0_10px_rgba(168,85,247,0.2)]'
                : 'hover:bg-purple-900/20'
              }`}
          >
            <div className={`p-1 ${isActive('/dashboard') ? 'bg-purple-900/40 rounded-md' : ''}`}>
              <LayoutDashboard className={`w-5 h-5 ${isActive('/dashboard')
                  ? 'text-purple-300'
                  : 'text-gray-400'
                }`} />
            </div>

            <span className={`text-[10px] font-medium ${isActive('/dashboard') ? 'text-purple-300' : 'text-gray-400'
              }`}>App</span>
          </Link>

          {/* Botón Mis CVs - NUEVO */}
          <Link
            to="/my-cvs"
            className={`relative flex flex-col items-center justify-center py-2.5 rounded-md transition-all duration-300 ${isActive('/my-cvs')
                ? 'bg-gradient-to-b from-emerald-600/40 to-emerald-800/30 border border-emerald-500/40 shadow-[0_0_10px_rgba(16,185,129,0.2)]'
                : 'hover:bg-emerald-900/20'
              }`}
          >
            <div className={`p-1 ${isActive('/my-cvs') ? 'bg-emerald-900/40 rounded-md' : ''}`}>
              <FileText className={`w-5 h-5 ${isActive('/my-cvs')
                  ? 'text-emerald-300'
                  : 'text-gray-400'
                }`} />
            </div>

            <span className={`text-[10px] font-medium ${isActive('/my-cvs') ? 'text-emerald-300' : 'text-gray-400'
              }`}>Mis CVs</span>
          </Link>

          {/* Botón Monedas */}
          <Link
            to="/coins"
            className={`relative flex flex-col items-center justify-center py-2.5 rounded-md transition-all duration-300 ${isActive('/coins')
                ? 'bg-gradient-to-b from-yellow-600/40 to-amber-800/30 border border-yellow-500/40 shadow-[0_0_10px_rgba(234,179,8,0.2)]'
                : 'hover:bg-yellow-900/20'
              }`}
          >
            <div className={`p-1 ${isActive('/coins') ? 'bg-yellow-900/40 rounded-md' : ''}`}>
              <Coins className={`w-5 h-5 ${isActive('/coins')
                  ? 'text-yellow-300'
                  : 'text-gray-400'
                }`} />
            </div>

            <span className={`text-[10px] font-medium ${isActive('/coins') ? 'text-yellow-300' : 'text-gray-400'
              }`}>Monedas</span>
          </Link>

          {/* Botón Mi Cuenta */}
          <Link
            to="/account"
            className={`relative flex flex-col items-center justify-center py-2.5 rounded-md transition-all duration-300 ${isActive('/account')
                ? 'bg-gradient-to-b from-indigo-600/40 to-indigo-800/30 border border-indigo-500/40 shadow-[0_0_10px_rgba(99,102,241,0.2)]'
                : 'hover:bg-indigo-900/20'
              }`}
          >
            <div className={`p-1 ${isActive('/account') ? 'bg-indigo-900/40 rounded-md' : ''}`}>
              <User className={`w-5 h-5 ${isActive('/account')
                  ? 'text-indigo-300'
                  : 'text-gray-400'
                }`} />
            </div>

            <span className={`text-[10px] font-medium ${isActive('/account') ? 'text-indigo-300' : 'text-gray-400'
              }`}>Mi Cuenta</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MobileNavBar; 